import React, { useRef, useState } from "react";
import Slider from "react-slick";
import LtModal from "../component/LtModal";

import {
  MdOutlineArrowBackIosNew,
  MdOutlineArrowForwardIos,
} from "react-icons/md";

const coaches = [
  {
    name: "Benny Lin Bing Chao",
    title: "Founder & Academy Director",
    image: "./assets/images/Coaches/Coach_Benny_Lin.jpg",
    description: `
<p>Benny Lin is an Olympian and one of Asia’s most accomplished tennis coaches. A former Head Coach and Coaching Director of the Hong Kong Tennis Association and Chinese Taipei Davis Cup Team, he holds the prestigious ITF Level 3 Coach Certificate, the highest globally recognized rating for a coach, as well as the USPTA Pro 1 Coaching Certificate.</p>

<h5>Tennis Playing Career:</h5>
<p>As a player, Benny achieved a career-high ATP World Ranking No. 240 and an ITF World Junior Ranking No. 4. Over a decade on the ATP Tour, he secured wins over Top 50 ATP players and competed in Grand Slam tournaments. His standout achievements include:
</p>
<ol>
<li>Representing Chinese Taipei in the Davis Cup, including a World Qualifying Group appearance in 1994.
</li>
<li>Competing at the 1992 Barcelona Olympic Games.
</li>
<li>Winning Silver and Bronze medals at the Asian Games (1 Silver, 3 Bronze).
</li>
<li>Champion of the Asian Championship Men’s Doubles in 1997 and a 4-time Men’s Singles Semifinalist (1994-1997).
</li>
<li>Silver and Bronze medals at the World University Games (1997, 1999).
</li>
<li>Reaching the semifinal of the French Open Boys' Doubles and quarterfinal of Wimbledon Junior Boys' Doubles in 1991.
</li>
<li>Winner of the East Asian Junior Championship Boys’ Singles in 1991.</li>
</ol>
<p>
Benny worked with world-renowned coaches such as Tony Roche (Roger Federer’s coach) and Suresh Menon (ITF Development Officer), refining his elite skill set and strategic understanding of the game.
</p>
<h5>
Coaching Career:
</h5>
<p>
As a coach, Benny has shaped the careers of numerous top players, from junior prodigies to ATP/WTA professionals. His coaching highlights include:
<p>
<ol>
<li>Serving as Director of Junior Development at the Hong Kong Tennis Association (2002-2007), where he mentored over 100 players and helped them achieve ITF Top 50 rankings.
</li>
<li>Coaching standout players like Venise Chan (ITF No. 25) and Zhang Ling (ITF No. 48), many of whom went on to earn college tennis scholarships and thrive on the professional circuit.
</li>
<li>Leading Hong Kong’s Junior Fed Cup Team to historic finishes, including third place in Asia and qualification for the World Group Final in 2005 and 2006.
</li>
<li>Coaching renowned ATP and WTA professionals, including Lu Yen-Hsun (ATP No. 36), Wang Yeu-Tzuoo (ATP No. 57), and Hsieh Su-Wei (WTA No. 114).</li>
</ol>
<p>
Benny is also recognized as an ITF Regional Expert in Player Development and one of Asia’s foremost authorities on tennis biomechanics. His innovative coaching methods have influenced numerous Tennis Associations and coaches across Asia. He has conducted coaching workshops and is a regular contributor to Tennis Magazine (China).
</p>
<h5>
Connection with U.S. Colleges & Contributions:
</h5>
<p>
Benny’s influence extends far beyond the tennis court. He is widely respected for his strategic connections with prestigious U.S. universities, having been the first coach from Asia to establish direct relationships with top schools. Through these connections, Benny has helped several of his students secure highly coveted tennis scholarships to compete at the collegiate level, providing a clear pathway to both academic and athletic success.
</p>
<p>
After his professional playing career, Benny himself received a scholarship to Azusa Pacific University in California, where he was named NAIA All-American, went undefeated with a 34-0 record, and was honored as GSAC Player of the Year and NAIA Rookie of the Year.</p>
			`,
  },
  {
    name: "Satender Gusain",
    title: "High Performance Coach",
    image: "./assets/images/Coaches/Coach_Satender_Gusain.jpeg",
    description:
      "<p>Coach Satender, hailing from India, is a dynamic former professional tennis player with an impressive legacy. As a junior competitor, he faced off against some of India’s top players, including Mahesh Bhupathi and Leander Paes. With 18 years of coaching experience under his belt, Coach Satender has specialized in nurturing young talent, guiding several juniors from their first swings to national-level success.</p><p> His extensive experience and deep understanding of the game make his training sessions both exhilarating and highly effective. Coach Satender’s commitment to developing future champions and his passion for the sport ensure that every player he trains gets the best start possible in their tennis journey.</p>",
  },
  {
    name: "Lea Lai",
    title: "Development Coach",
    image: "./assets/images/Coaches/Coach_Lea_Lai.jpeg",
    description:
      "<p>Coach Lea has been a cornerstone of the HK International Tennis Academy since 2009, specializing in mini tennis. With a Coaching Expert Certificate for kids' tennis and extensive training from the Hong Kong Tennis Association, the International Tennis Federation, and the Professional Tennis Registry, she brings a wealth of expertise to her role.</p><p> Over the years, Coach Lea has introduced thousands of young players to the sport, nurturing many from beginners to top players in Hong Kong. In addition to her hands-on coaching, she has played a pivotal role in developing the mini tennis program at HKITA and mentoring fellow mini tennis coaches. Her dedication and innovative approach ensure that every child she teaches receives an exceptional start in tennis.</p>",
  },
  {
    name: "Deepak Nair",
    title: "High Performance Coach",
    image: "./assets/images/Coaches/Coach_Deepak_Nair.jpeg",
    description:
      "<p>Coach Deepak brings over a decade of coaching experience to the court, holding certifications as an International Tennis Federation (ITF) Level 1 coach and a United States Professional Tennis Registry (USPTR) Senior Level coach. Specializing in junior development, he is dedicated to teaching fundamental and coordination skills that enhance both athleticism and tennis prowess.</p> <p>Coach Deepak’s passion lies in making tennis lessons engaging and challenging, aiming to foster a love for the sport that lasts a lifetime. He takes pride in witnessing his students master new skills and grow as players.</p> <p>Previously, Coach Deepak mentored Rohan Mehra, who has since advanced to the ATP Tour as a professional tennis player.</p>",
  },
];

const CoachList = () => {
  const sliderRef = useRef(null);
  const [show, setShow] = useState(false); // State for modal visibility
  const [selectedCoach, setSelectedCoach] = useState(null); // State for selected coach

  const handleClose = () => setShow(false);
  const handleShow = (coach) => {
    setSelectedCoach(coach);
    setShow(true);
  };

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    // centered: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="bg-gray-50 py-8 overflow-hidden">
      <div className="container mx-auto px-4 py-12">
        <div className="col-md-12 text-center mb-5 heading pr-5 md:pr-3">
          <h6 className="text-theme">Highlight</h6>
          <h2 className="mb-4 font-bold headingFont">Our Coaches</h2>
          {/* <p className="mb-0 text-center">
						We are happy to announce a new addition to our programme offer, which is an annual programme addressed to younger players, starting the
						week of September 9th.
					</p>
					<p className="mb-0 text-center">
						Education has always been one of our priorities. Our junior development programmes are created in such a way that allows players to both
						train and study.
					</p> */}
        </div>
        <Slider ref={sliderRef} {...settings}>
          {coaches.map((coach, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center px-2"
            >
              <div className="program_card" onClick={() => handleShow(coach)}>
                <img
                  src={coach.image}
                  alt={coach.name}
                  className="aspect-square h-[300px] w-full max-w-[300px] rounded object-cover shadow-sm"
                />
                <div className="sectionInfo p-4">
                  <h5 className="text-xl font-bold mb-2">{coach.name}</h5>
                  <p className="text-sm text-white">{coach.title}</p>
                </div>
              </div>
              <div className="flex flex-col p-4 text-center lg:hidden">
                <h5 className="mb-2 text-xl font-bold">{coach.name}</h5>
                <p className="text-sm">{coach.title}</p>
              </div>
            </div>
          ))}
        </Slider>

        <div className="mt-4 text-center">
          <button
            onClick={() => sliderRef.current.slickPrev()}
            className="inline-block h-[50px] w-[50px] bg-black hover:scale-110 border-none transition-all hover:bg-slate-800 rounded-full m-2 pb-1"
          >
            <MdOutlineArrowBackIosNew className="text-white" />
          </button>
          <button
            onClick={() => sliderRef.current.slickNext()}
            className="inline-block h-[50px] w-[50px] bg-black hover:scale-110 border-none transition-all hover:bg-slate-800 rounded-full m-2 pb-1"
          >
            <MdOutlineArrowForwardIos className="text-white" />
          </button>
        </div>

        {/* Bootstrap Modal */}
        <LtModal isOpen={show} onClose={handleClose} heading="" width={500}>
          <div className="text-center mx-auto">
            <img
              src={selectedCoach?.image}
              alt={selectedCoach?.name}
              className="mb-3 h-[200px] w-[200px] object-cover rounded-lg mx-auto"
            />
          </div>
          <h4 className="mt-3 text-center fw-bold">{selectedCoach?.title}</h4>
          <p className="text-center">{selectedCoach?.country}</p>
          <p
            className="text-justify"
            dangerouslySetInnerHTML={{ __html: selectedCoach?.description }}
          />
        </LtModal>
      </div>
    </div>
  );
};

export default CoachList;
